import React, { useState, useEffect } from 'react';
import { IAmountPayableProps } from './AmountPayable.types';
import {
  useFlowData,
  formatString,
  StringFormats,
} from '@adaptis/flow-components';

import './AmountPayable.scss';

export default function AmountPayable(props: IAmountPayableProps) {
  const { getData } = useFlowData();
  const [amountToDisplay, SetAmountToDisplay] = useState(String);

  // should be called ONCE on rendering
  // if the props.dataField is set, and has a value, use that value
  // otherwise check if props.amount is set and use that value
  useEffect(() => {
    if (props.dataField !== undefined && props.dataField != '') {
      SetAmountToDisplay(getData(props.dataField));
    } else if (amountToDisplay == undefined || amountToDisplay == '') {
      if (props.amount !== undefined) {
        SetAmountToDisplay(props.amount.toString());
      }
    }
  }, []);

  return (
    <div data-testid='AmountPayable' className='flc_amount-payable'>
      <div className='label  text-style-1'>{props.label}</div>
      <div className='amount'>
        {formatString(amountToDisplay, StringFormats.Currency)}
      </div>
    </div>
  );
}
